export const getPlatform = (): {
  userAgent: string;
  browser: boolean;
  ios: boolean;
  platform: string;
} => {
  const platform = window.navigator.platform,
    userAgent = window.navigator.userAgent.toLowerCase(),
    browser = /safari/.test(userAgent) || /chrome/.test(userAgent) || /firefox/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);
  return {
    platform,
    userAgent,
    browser,
    ios
  };
};
